import * as TK from 'components/site/SiteCreationDialog/translations/constants';
import { Translations } from 'translations/types';

export const siteCreationDialogEnUsLocale: Translations = {
  [TK.SITE_CREATION_DIALOG_TITLE]: 'You’re all set!',
  [TK.SITE_CREATION_DIALOG_DESCRIPTION]: 'Your site has been successfully created and account has been verified',
  [TK.SITE_CREATION_DIALOG_BUTTON_TEXT]: 'Go to home',
  [TK.SITE_CREATION_DIALOG_ICON_ALT]: 'Done icon',
};
